import { render } from "./DonateCTA.vue?vue&type=template&id=83516c68&scoped=true"
import script from "./DonateCTA.vue?vue&type=script&lang=js"
export * from "./DonateCTA.vue?vue&type=script&lang=js"

import "./DonateCTA.vue?vue&type=style&index=0&id=83516c68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83516c68"]])

export default __exports__